module.exports = __webpack_public_path__ + "static/Outlook-bf5f3469fbcc4bcb7896b0a6e2cbd36f.png";